module.exports = __webpack_public_path__ + "static/media/buy-exide-ing-merch.00286b12.svg";